import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import checkIcon from "../../../assets/images/icons/check.svg";
import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";
import rewardLockedIcon from "../../../assets/images/icons/locked.svg";

export type AddButtonVariant = "standard" | "inverted" | "disabled";

export const MerchCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 300px;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const MerchCardImageHolder = styled(({ backgroundColor, isLocked, ...rest }) => <Link {...rest} />)`
  position: relative;
  width: 100%;
  height: 0;
  float: left;
  padding-bottom: 100%;
  cursor: pointer;
  background-color: ${(props) => props.backgroundColor};
  ${(props) =>
    props.isLocked &&
    css`
      &:after {
        content: " ";
        display: block;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        background: ${colors.blackTransparent};
      }
    `}
`;

export const MerchCardImg = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  object-fit: contain;
  padding: 44px 24px 24px 24px;

  ${breakpoints.smDown} {
    padding: 33px 16px 24px 16px;
  }
`;

export const MerchTitle = styled(Link)`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 20px;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 31px;
  cursor: pointer;

  ${breakpoints.smDown} {
    font-size: 16px;
    line-height: 16px;
    height: 22px;
  }
`;

export const MerchCardFooter = styled.div`
  cursor: auto;
  height: 80px;
  border: 1px solid ${colors.black};
  border-top: none;
  padding: 10px;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${breakpoints.smDown} {
    height: 67px;
    padding: 5px 8px 10px 8px;
    justify-content: space-between;
  }
`;

export const MerchCardFooterBottomRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const InfoLabel = styled.div<{ color: string }>`
  display: inline-block;
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 16px;
  line-height: 15px;
  color: ${(props) => props.color};

  ${breakpoints.smDown} {
    font-size: 14px;
  }
`;

export const NewStockInfoLabel = styled(InfoLabel)`
  color: ${colors.success};
`;

export const NoStockInfoLabel = styled(InfoLabel)`
  color: ${colors.success};
`;

export const PriceWrapper = styled.div`
  display: flex;
  margin-right: 0px;
  margin-left: auto;
  align-items: center;
`;

export const PriceLabel = styled.div`
  display: inline-block;
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 25px;
  line-height: 27px;

  ${breakpoints.smDown} {
    font-size: 19px;
    line-height: 17px;
  }
`;

export const AddButton = styled.button<{
  variant: AddButtonVariant;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 1px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.5;
  padding: 9px 10px;
  text-transform: uppercase;
  font-family: ${fonts.fontBauMedium};
  background-color: ${colors.black};
  color: ${colors.white};
  border: 1px solid ${colors.black};

  ${breakpoints.mdDown} {
    padding: 8px 10px;
  }

  ${(props) =>
    props.variant === "inverted" &&
    css`
      color: ${colors.black};
      background-color: ${colors.white};
      &:hover {
        color: ${colors.white};
        background-color: ${colors.black};
      }
    `};

  ${(props) =>
    props.variant === "disabled" &&
    css`
      border: 1px solid ${colors.gray};
      color: ${colors.white};
      background-color: ${colors.gray};
      &:hover {
        background-color: ${colors.gray};
        color: ${colors.white};
      }
    `};

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Tag = styled.div<{
  isDesktop: boolean;
  backgroundColor: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.backgroundColor};
  border-radius: 10px;
  padding: 1px 5px;

  position: absolute;
  top: 8px;
  right: 8px;

  ${(props) =>
    props.isDesktop &&
    css`
      position: absolute;
      top: 20px;
      right: 10px;
    `}
`;

export const CheckIcon = styled.img.attrs(() => ({ src: checkIcon }))`
  width: 8px;
  height: 7px;
  margin-right: 5px;
`;

export const TagText = styled.div`
  font-family: ${fonts.fontBauMedium};
  font-size: 9px;
  line-height: 15px;
  text-transform: uppercase;
`;

export const RewardLockedIcon = styled.img.attrs(() => ({ src: rewardLockedIcon }))`
  width: 18px;
  height: 18px;
`;
